const FormSubmittedTick = () => {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2 29.7L31.3 15.6L28.5 12.8L17.2 24.1L11.5 18.4L8.7 21.2L17.2 29.7ZM20 40.5C17.2333 40.5 14.6333 39.975 12.2 38.925C9.76667 37.875 7.65 36.45 5.85 34.65C4.05 32.85 2.625 30.7333 1.575 28.3C0.525 25.8667 0 23.2667 0 20.5C0 17.7333 0.525 15.1333 1.575 12.7C2.625 10.2667 4.05 8.15 5.85 6.35C7.65 4.55 9.76667 3.125 12.2 2.075C14.6333 1.025 17.2333 0.5 20 0.5C22.7667 0.5 25.3667 1.025 27.8 2.075C30.2333 3.125 32.35 4.55 34.15 6.35C35.95 8.15 37.375 10.2667 38.425 12.7C39.475 15.1333 40 17.7333 40 20.5C40 23.2667 39.475 25.8667 38.425 28.3C37.375 30.7333 35.95 32.85 34.15 34.65C32.35 36.45 30.2333 37.875 27.8 38.925C25.3667 39.975 22.7667 40.5 20 40.5Z"
        fill="#2ABF80"
      />
    </svg>
  );
};

export default FormSubmittedTick;
